import React from 'react';

const ModernTitleBanner = () => {
  return (
    <div className="modern-header">
      <h1 style={{ margin: 0, fontSize: '2.5rem', fontWeight: '700' }}>
        Better by December
      </h1>
      <p style={{ margin: '0.5rem 0 0 0', fontSize: '1.1rem', opacity: 0.9 }}>
        Track your progress, achieve your goals
      </p>
    </div>
  );
};

export default ModernTitleBanner;